import axios from 'axios';
import Swal from 'sweetalert2';

let baseUrl = '';
export let imgBaseUrl = '';
export let configMessage = '';

export const initializeUrls = () => {
    baseUrl = process.env.REACT_APP_BASE_URL;
    imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    configMessage = process.env.REACT_APP_READY_TO_SEND_TITLE;

    axios.defaults.baseURL = baseUrl;
    axios.defaults.withCredentials = false;
};


initializeUrls();

const apiInstance = axios.create({
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
    },
});

apiInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')?.replace(/"/g, '');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('userData');
            sessionStorage.removeItem('cartItems');
            localStorage.removeItem('token');
            window.location.href = '/login';
        } else {
            Swal.fire({
                icon: 'error',
                title: 'خطایی رخ داده است',
                text: error.response?.data?.message || 'لطفا مجدد تلاش کنید',
            });
            console.log(error);
        }
        return Promise.reject(error);
    }
);

const api = async (method, url, params = {}) => {
    if (method === 'get') {
        return await apiInstance.get(url, { params });
    }
    if (method === 'post') {
        return await apiInstance.post(url, params);
    }
    if (method === 'postQuery') {
        const queryParams = new URLSearchParams(params.query).toString();
        return await apiInstance.post(`${url}?${queryParams}`, params.raw);
    }
    if (method === 'test') {
        return await apiInstance.post('https://httpbin.org/status/401');
    }
};

// User APIs
export const IsMobileExsits = (params) => api('post', `/User/IsMobileExsits`, params);
export const sendOtp = (params) => api('post', `/User/SendOtp`, params);
export const loginByPass = (params) => api('post', `/User/LoginByPass`, params);
export const loginByOtp = (params) => api('post', `/User/LoginByOtp`, params);
export const RegisterByOtp = (params) => api('post', `/Register/Fast`, params);
export const sendRegisterOtp = (params) => api('post', `/Register/SendOtp`, params);
export const registerCheckOtp = (params) => api('post', `/Register/CheckOtp`, params);
export const register = (params) => api('post', `/Register`, params);
export const getUserInfo = () => api('get', `/User`);
export const getEditUser = (params) => api('post', `/User/Edit`, params);
export const getUserCard = (params) => api('post', `/Card/UserCards`, params);
export const getUserCharges = (params) => api('post', `/Card/UserCharges`, params);
export const getCharge = (params) => api('post', `/Card/Charge`, params);
export const getInventory = (params) => api('post', `/Card/Inventory`, params);

// Catalog
export const CatalogSendOtp = (params) => api('post', `/Catalog/SendOtp`, params);
export const CatalogRegister = (params) => api('post', `/Catalog/RegisterUser`, params);

// Change Password
export const sendOtpChangePassword = (params) => api('post', `/ChangePassword/SendOtp`, params);
export const checkOtpChangePassword = (params) => api('post', `/ChangePassword/CheckOtp`, params);
export const ChangePassword = (params) => api('post', `/ChangePassword`, params);

// Category & Product
export const getCategories = (params) => api('get', `/Category/GetList`, params);
export const getProductsBySearch = (params) => api('post', `/Product/Search`, params);
export const getProductsById = (id) => api('get', `/Product/${id}`);
export const getTermsConditions = (params) => api('get', `/Pages/TermsConditions`, params);
export const getAboutUs = (params) => api('get', `/Pages/AboutUs`, params);
export const getHomeSliders = () => api('get', `/Pages/Slider`);
export const getShortLink = (code) => api('get', `/Pages/ShortLink/${code}`);

// Settings
export const getProvince = () => api('get', `/Setting/Provinces`);
export const getCity = (params) => api('post', `/Setting/Cities`, params);
export const getSettings = (params) => api('get', `/Setting/Get`, params);

// Card
export const getMyCard = () => api('get', `/Card/UserCards`);
export const buyCard = (params) => api('post', `/Card/Buy`, params);
export const fastCharge = (params) => api('post', `/Card/FastCharge`, params);
export const BuyConfirm = (params) => api('post', `/Card/BuyConfirm`, params);
export const UpdateCard = (params) => api('post', `/Card/Update`, params);

// Basket
export const addToBasket = (params) => api('post', `/Basket`, params);
export const deleteFromBasket = (params) => api('post', `/Basket/Delete`, params);
export const setCountBasketList = (params) => api('post', `/Basket/SetCount`, params);
export const getBasketList = (params) => api('get', `/Basket/${params}`);

// checkCharge
export const checkCardCharge = (params) => api('post', `/Card/checkCharge`, params);
